export const OPENAI_MODEL = "gpt-4o";